"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isImagesProperty = exports.imagesPropertyDefinition = void 0;
exports.imagesPropertyDefinition = {
    view: { label: 'Images' },
    constraints: [
        {
            name: 'properties',
            argument: ['image'],
        },
        {
            name: 'minLength',
            argument: 3,
        },
    ],
    type: 'container',
    multiple: true,
    name: 'images',
};
const isImagesProperty = (prop) => {
    return prop.name === exports.imagesPropertyDefinition.name;
};
exports.isImagesProperty = isImagesProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW1hZ2VzLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvaW1hZ2VzLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsd0JBQXdCLEdBQUc7SUFDdEMsSUFBSSxFQUFFLEVBQUUsS0FBSyxFQUFFLFFBQVEsRUFBRTtJQUN6QixXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxZQUFZO1lBQ2xCLFFBQVEsRUFBRSxDQUFDLE9BQU8sQ0FBQztTQUNwQjtRQUNEO1lBQ0UsSUFBSSxFQUFFLFdBQVc7WUFDakIsUUFBUSxFQUFFLENBQUM7U0FDWjtLQUNGO0lBQ0QsSUFBSSxFQUFFLFdBQVc7SUFDakIsUUFBUSxFQUFFLElBQUk7SUFDZCxJQUFJLEVBQUUsUUFBUTtDQUNpQixDQUFBO0FBSTFCLE1BQU0sZ0JBQWdCLEdBQUcsQ0FBQyxJQUFrQixFQUEwQixFQUFFO0lBQzdFLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyxnQ0FBd0IsQ0FBQyxJQUFJLENBQUE7QUFDcEQsQ0FBQyxDQUFBO0FBRlksUUFBQSxnQkFBZ0Isb0JBRTVCIn0=